import { render, staticRenderFns } from "./AddDashboardPage.vue?vue&type=template&id=55198b8c&"
import script from "./AddDashboardPage.vue?vue&type=script&lang=js&"
export * from "./AddDashboardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports